import { ErrorBoundary, withErrorBoundary } from "@sentry/react";

export const ErrorBoundaryHoc = withErrorBoundary;

export default ErrorBoundary;
